import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import { init } from "./logger";
import App from "./App";

init();

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
  <Router>
    <App />
  </Router>
);
